// extracted by css-extract-rspack-plugin
export default {"formButton":"formButton__TngZb","exampleRow":"exampleRow__asKrT","formElement":"formElement__Zi9XO","exampleRow_withRequest":"exampleRow_withRequest__XIdHm"};